<template>
  <ValidationObserver ref="observer" v-slot="{ passes }">
    <b-modal size="lg" :visible="isVisible" :title="editingItem.pk ? 'Editar' : 'Adicionar'" @ok.prevent="sendItem" @cancel.prevent="handleCancel" @hidden="$emit('clear-modal')" cancel-title="Cancelar" ok-title="Salvar">
      <b-form ref="modalForm" @submit.prevent>
      
      <!--
      contract_type
      customer
      title
      description
      success_fees
      success_fees_num
      start_date
      limit_months
      limit_hours
      contract_hours
      date_of_readjustment
      index_of_readjustment
      index_type
      end_date
      value
      currency_money
      due_date
      payment_type
      document
      active
      sinal
      number_installments
      -->

      <b-row>
        <!-- Primeira coluna -->
        <b-col>

          <!-- contract_type -->
           
<b-form-group label-for="item-contract_type">
  <template #label>
    Tipo de contrato
  </template>
  <b-form-select
    v-if="editingItem.pk"
    required
    id="item-contract_type"
    v-model="editingItem.version.contract_type"
    :options="contract_types"
  ></b-form-select>
  <b-form-select
    v-else
    required
    id="item-contract_type"
    v-model="editingItem.contract_type"
    :options="contract_types"
  ></b-form-select>
</b-form-group>

<!-- customer -->
<ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
  <b-form-group label-for="item-customer" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
    <template #label>
      Cliente *
    </template>
    <v-select
      required
      v-if="editingItem.version"
      :disabled="true"
      v-model="editingItem.customer_pk"
      id="item-customer"
      :reduce="item => item.value"
      label="text"
      :options="customers"
    />
    <v-select
      v-else
      required
      v-model="editingItem.customer_pk"
      id="item-customer"
      :reduce="item => item.value"
      label="text"
      :options="customers"
    />
  </b-form-group>
</ValidationProvider>

<!-- title -->
<ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
  <b-form-group label-for="item-title" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
    <template #label>
      Título *
    </template>
    <b-input
      v-if="editingItem.pk"
      required
      id="item-title"
      type="text"
      v-model="editingItem.version.title"
    ></b-input>
    <b-input
      v-else
      required
      id="item-title"
      type="text"
      v-model="editingItem.title"
    ></b-input>
  </b-form-group>
</ValidationProvider>

<!-- description -->
<b-form-group label-for="item-description">
  <template #label>
    Descrição
  </template>
  <b-form-textarea
    v-if="editingItem.pk"
    id="item-description"
    v-model="editingItem.version.description"
    placeholder="Descrição do contrato..."
    rows="10"
  ></b-form-textarea>
  <b-form-textarea
    v-else
    id="item-description"
    v-model="editingItem.description"
    placeholder="Descrição do contrato..."
    rows="10"
  ></b-form-textarea>
</b-form-group>

<!-- start_date -->
<ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
  <b-form-group label-for="item-start_date" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
    <template #label>
      Data de início de vigência *
    </template>
    <datepicker
      v-if="editingItem.pk"
      required
      :input-attr="{required: 'true'}"
      id="item-start_date"
      v-model="editingItem.version.start_date"
      format="dd/MM/yy"
      :highlighted="state.highlighted"
      input-class="form-control"
      :typeable="false"
      :use-utc="true"
    ></datepicker>
    <datepicker
      v-else
      required
      :input-attr="{required: 'true'}"
      id="item-start_date"
      v-model="editingItem.start_date"
      format="dd/MM/yy"
      :highlighted="state.highlighted"
      input-class="form-control"
      :typeable="false"
      :use-utc="true"
    ></datepicker>
  </b-form-group>
</ValidationProvider>

<!-- limit_months -->
<ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
  <b-form-group label-for="item-limit_months" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
    <template #label>
      Duração do contrato *
      <br>
      <small class="text-muted">Em meses. Para prazo indeterminado, deixe 0.</small>
    </template>
    <b-input
      required
      id="item-limit_months"
      type="number"
      min="0"
      step="1"
      v-model="editingItem.limit_months"
    ></b-input>
  </b-form-group>
</ValidationProvider>

<!-- Additional logic for contract_type 'm' -->
<div v-if="(editingItem.contract_type === 'm') || (editingItem.version && editingItem.version.contract_type === 'm')">
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label="Há teto de horas? *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <b-form-radio-group
        v-if="editingItem.pk"
        required
        v-model="editingItem.version.has_hour_limit"
        :options="[{ value: true, text: 'Sim' }, { value: false, text: 'Não' }]"
      ></b-form-radio-group>
      <b-form-radio-group
        v-else
        required
        v-model="editingItem.has_hour_limit"
        :options="[{ value: true, text: 'Sim' }, { value: false, text: 'Não' }]"
      ></b-form-radio-group>
    </b-form-group>
  </ValidationProvider>

  <div v-if="(editingItem.has_hour_limit) || (editingItem.version && editingItem.version.has_hour_limit)">
    <!-- limit_hours -->
    <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
      <b-form-group label-for="item-contract_hours" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
        <template #label>
          Teto de Horas *
        </template>
        <b-input
          v-if="editingItem.pk"
          required
          id="item-contract_hours"
          type="number"
          min="0"
          step="1"
          v-model="editingItem.version.limit_hours"
        ></b-input>
        <b-input
          v-else
          required
          id="item-contract_hours"
          type="number"
          min="0"
          step="1"
          v-model="editingItem.limit_hours"
        ></b-input>
      </b-form-group>
    </ValidationProvider>

    <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
      <b-form-group label="Haverá banco de horas? *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
        <b-form-radio-group
          v-if="editingItem.pk"
          required
          v-model="editingItem.version.has_timebank"
          :options="[{ value: true, text: 'Sim' }, { value: false, text: 'Não' }]"
        ></b-form-radio-group>
        <b-form-radio-group
          v-else
          required
          v-model="editingItem.has_timebank"
          :options="[{ value: true, text: 'Sim' }, { value: false, text: 'Não' }]"
        ></b-form-radio-group>
      </b-form-group>
    </ValidationProvider>

    <div v-if="(editingItem.has_timebank) || (editingItem.version && editingItem.version.has_timebank)">
      <!-- valor da hora do contrato -->
      <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
        <b-form-group label="Valor da hora *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
          <b-input-group prepend="R$">
            <b-input
              v-if="editingItem.version"
              required
              type="number"
              min="1"
              step="1"
              v-model="editingItem.version.timebank_hour_value"
            ></b-input>
            <b-input
              v-else
              required
              type="number"
              min="1"
              step="1"
              v-model="editingItem.timebank_hour_value"
            ></b-input>
          </b-input-group>
        </b-form-group>
      </ValidationProvider>

      <!-- periodicidade para cobrança do banco de horas -->
      <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
        <b-form-group label="Periodicidade para cobrança do banco de horas *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
          <small class="text-muted" style="display: block; margin-top: -.2rem; margin-bottom: .5rem">Em meses.</small>
          <b-input
            v-if="editingItem.version"
            required
            id="item-contract_hours"
            type="number"
            min="0"
            step="1"
            v-model="editingItem.version.timebank_charge_frequency"
          ></b-input>
          <b-input
            v-else
            required
            id="item-contract_hours"
            type="number"
            min="0"
            step="1"
            v-model="editingItem.timebank_charge_frequency"
          ></b-input>
        </b-form-group>
      </ValidationProvider>
    </div>
  </div>
</div>

<!-- Additional logic for contract_type 'h' -->
<div v-if="(editingItem.contract_type === 'h') || (editingItem.version && editingItem.version.contract_type === 'h')">
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label="Modelo *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <b-form-radio-group
        v-if="editingItem.pk"
        required
        v-model="editingItem.version.contract_model"
        :options="[{ value: 'free_hours', text: 'Horas livres' }, { value: 'hour_package', text: 'Pacote de horas' }]">
      </b-form-radio-group>
      <b-form-radio-group
        v-else
        required
        v-model="editingItem.contract_model"
        :options="[{ value: 'free_hours', text: 'Horas livres' }, { value: 'hour_package', text: 'Pacote de horas' }]">
      </b-form-radio-group>
    </b-form-group>
  </ValidationProvider>
</div>

<div v-if="(editingItem.contract_type === 'p') || (editingItem.version && editingItem.version.contract_type === 'p')">
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label="Modelo *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <b-form-radio-group
        v-if="editingItem.pk"
        required
        v-model="editingItem.version.contract_model"
        :options="[{ value: 'fixed_value', text: 'Valor Fixo' }, { value: 'hour_package', text: 'Pacote de horas' }]">
      </b-form-radio-group>
      <b-form-radio-group
        v-else
        required
        v-model="editingItem.contract_model"
        :options="[{ value: 'fixed_value', text: 'Valor Fixo' }, { value: 'hour_package', text: 'Pacote de horas' }]">
      </b-form-radio-group>
    </b-form-group>
  </ValidationProvider>
</div>

<div v-if="(editingItem.contract_model === 'hour_package') || (editingItem.version && editingItem.version.contract_model === 'hour_package')">
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label="Número de horas *" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <b-input
        v-if="editingItem.pk"
        required
        id="item-limit_hours"
        type="number"
        min="0"
        step="1"
        v-model="editingItem.version.limit_hours"
      ></b-input>
      <b-input
        v-else
        required
        id="item-limit_hours"
        type="number"
        min="0"
        step="1"
        v-model="editingItem.limit_hours"
      ></b-input>
    </b-form-group>
  </ValidationProvider>
</div>
</b-col>
<!-- Segunda coluna -->
<b-col>
  <div v-if="(editingItem.contract_type !== 'p') || (editingItem.contract_model === 'hour_package') || (editingItem.version && editingItem.version.contract_type !== 'p') || (editingItem.version && editingItem.version.contract_model === 'hour_package')">
    <!-- date_of_readjustment -->
    <b-form-group label-for="item-date_of_readjustment">
      <template #label>
        Data de reajuste
      </template>
      <datepicker
        v-if="editingItem.pk"
        id="item-date_of_readjustment"
        v-model="editingItem.version.date_of_readjustment"
        format="dd/MM/yy"
        :highlighted="state.highlighted"
        input-class="form-control"
        :typeable="false"
        :use-utc="true"
      ></datepicker>
      <datepicker
        v-else
        id="item-date_of_readjustment"
        v-model="editingItem.date_of_readjustment"
        format="dd/MM/yy"
        :highlighted="state.highlighted"
        input-class="form-control"
        :typeable="false"
        :use-utc="true"
      ></datepicker>
    </b-form-group>

    <!-- index_of_readjustment -->
    <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
      <b-form-group label-for="item-index_of_readjustment" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]" hidden>
        <b-input
          v-if="editingItem.pk"
          id="item-index_of_readjustment"
          type="number"
          min="1"
          max="2"
          step="0.01"
          v-model="editingItem.version.index_of_readjustment"
        ></b-input>
        <b-input
          v-else
          id="item-index_of_readjustment"
          type="number"
          min="1"
          max="2"
          step="0.01"
          v-model="editingItem.index_of_readjustment"
        ></b-input>
      </b-form-group>
    </ValidationProvider>

    <!-- index_type -->
    <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
      <b-form-group label-for="item-index_type" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
        <template #label>
          Tipo de índice *
        </template>
        <b-form-select
          v-if="editingItem.pk"
          required
          id="item-index_type"
          v-model="editingItem.version.index_type"
          :options="index_types"
        ></b-form-select>
        <b-form-select
          v-else
          required
          id="item-index_type"
          v-model="editingItem.index_type"
          :options="index_types"
        ></b-form-select>

      </b-form-group>
    </ValidationProvider>

    <!-- end_date -->
  </div>

  <!-- currency_money -->
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label-for="item-currency_money" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <template #label>
        Moeda *
      </template>
      <b-form-select
        required
        id="item-currency_money"
        v-model="editingItem.currency_money"
        :options="currency_moneys"
      ></b-form-select>
    </b-form-group>
  </ValidationProvider>

  <!-- value -->
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label-for="item-value" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <template #label>
        Valor *
      </template>
      <b-input-group :prepend="icon" class="mb-2 mr-sm-2 mb-sm-0">
        <b-input
          v-if="editingItem.version"
          required
          id="item-value"
          type="number"
          min="0"
          step="0.01"
          v-model="editingItem.version.value"
        ></b-input>
        <b-input
          v-else
          required
          id="item-value"
          type="number"
          min="0"
          step="0.01"
          v-model="editingItem.value"
        ></b-input>
      </b-input-group>
    </b-form-group>
  </ValidationProvider>

  <!-- if editingItem.contract_type equals p, then show radio input 'Haverá sinal de pagamento?' If chosen option is yes, then show input 'Valor do Sinal'. If chosen option is no, don't show valor do sinal.-->
  <div v-if="editingItem.contract_type === 'p'">
    <b-form-group label="Haverá/houve sinal de pagamento? *">
      <b-form-radio-group
        v-if="editingItem.pk"
        required
        v-model="editingItem.version.isThereSinal"
        :options="[{ value: 'yes', text: 'Sim' }, { value: 'no', text: 'Não' }]"
      ></b-form-radio-group>
      <b-form-radio-group
        v-else
        required
        v-model="editingItem.isThereSinal"
        :options="[{ value: 'yes', text: 'Sim' }, { value: 'no', text: 'Não' }]"
      ></b-form-radio-group>
    </b-form-group>
    <b-form-group label-for="item-sinal" v-if="editingItem.isThereSinal === 'yes'">
      <template #label>
        Valor do Sinal *
      </template>
      <b-input-group :prepend="icon" class="mb-2 mr-sm-2 mb-sm-0">
        <b-input
          v-if="editingItem.version"
          required
          id="item-sinal"
          type="number"
          min="0"
          step="0.01"
          v-model="editingItem.version.sinal"
        ></b-input>
        <b-input
          v-else
          required
          id="item-sinal"
          type="number"
          min="0"
          step="0.01"
          v-model="editingItem.sinal"
        ></b-input>
      </b-input-group>
    </b-form-group>
  </div>

  <!-- Início de recorrência da cobrança -->
  <div v-if="(editingItem.contract_type === 'h') || (editingItem.version && editingItem.version.contract_type === 'h')">
    <b-form-group label="Início de recorrência da cobrança *">
      <datepicker
        v-if="editingItem.pk"
        required
        v-model="editingItem.version.due_date"
        format="dd/MM/yy"
        :highlighted="state.highlighted"
        input-class="form-control"
        :typeable="false"
        :use-utc="true"
      ></datepicker>
      <datepicker
        v-else
        required
        v-model="editingItem.due_date"
        format="dd/MM/yy"
        :highlighted="state.highlighted"
        input-class="form-control"
        :typeable="false"
        :use-utc="true"
      ></datepicker>
    </b-form-group>

    <!-- Periodicidade -->
    <b-form-group label="Periodicidade da cobrança. A cada: *">
      <b-form-select
        v-if="editingItem.version"
        required
        v-model="editingItem.version.billing_recurrence"
        :options="billing_recurrences"
      ></b-form-select>
      <b-form-select
        v-else
        required
        v-model="editingItem.billing_recurrence"
        :options="billing_recurrences"
      ></b-form-select>
    </b-form-group>
  </div>

  <!-- due_date -->
  <div v-if="!((editingItem.contract_type === 'h') || (editingItem.version && editingItem.version.contract_type === 'h'))">
    <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
      <b-form-group label-for="item-due_date" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
        <template #label>
          {{ dueDateLabel }} *
        </template>
       <datepicker
        v-if="editingItem.version"
        required
        id="item-due_date"
        v-model="editingItem.version.due_date"
        format="dd/MM/yy"
        :highlighted="state.highlighted"
        input-class="form-control"
        :typeable="false"
        :use-utc="true"
      ></datepicker>
      <datepicker
        v-else
        required
        id="item-due_date"
        v-model="editingItem.due_date"
        format="dd/MM/yy"
        :highlighted="state.highlighted"
        input-class="form-control"
        :typeable="false"
        :use-utc="true"
      ></datepicker>
      </b-form-group>
    </ValidationProvider>
  </div>

  <!-- payment_type -->
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group label-for="item-payment_type" v-if="(editingItem.contract_type === 'p' || (editingItem.version && editingItem.version.contract_type === 'p')) && (editingItem.contract_model === 'fixed_value' || (editingItem.version && editingItem.version.contract_model === 'fixed_value'))" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <template #label>
        Forma de pagamento *
      </template>
      <b-form-select
        v-if="editingItem.pk"
        required
        id="item-payment_type"
        v-model="editingItem.version.payment_type"
        :options="payment_types"
      ></b-form-select>
      <b-form-select
        v-else
        required
        id="item-payment_type"
        v-model="editingItem.payment_type"
        :options="payment_types"
      ></b-form-select>
    </b-form-group>
  </ValidationProvider>

  <!-- número de parcelas -->
  <ValidationProvider rules="required" v-slot="{ valid, touched, errors }">
    <b-form-group v-if="(editingItem.payment_type === 'p' && editingItem.contract_model === 'fixed_value') || (editingItem.version && (editingItem.version.payment_type === 'p' && editingItem.version.contract_model === 'fixed_value'))" label-for="item-number_installments" :state="!valid && errors[0] ? false : null" :invalid-feedback="errors[0]">
      <template #label>
        Número de parcelas *
      </template>
      <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-form-select
          v-if="editingItem.pk"
          required
          id="item-number_installments"
          v-model="editingItem.version.number_installments"
          :options="installmentsOptions"
        ></b-form-select>
        <b-form-select
          v-else
          required
          id="item-number_installments"
          v-model="editingItem.number_installments"
          :options="installmentsOptions"
        ></b-form-select>
      </b-input-group>
    </b-form-group>
  </ValidationProvider>

  <!-- Show valor das parcelas if there number_installments. Subtract the editingItem.value or editingItem.version.value minus the sinal if there is a sinal, then divide by the number_installments to get the parcelas value. -->
  <div v-if="(editingItem.payment_type === 'p' && editingItem.contract_model === 'fixed_value') || (editingItem.version && (editingItem.version.payment_type === 'p' && editingItem.version.contract_model === 'fixed_value'))">
    <b-form-group label="Valor das parcelas *">
      <b-input-group :prepend="icon" class="mb-2 mr-sm-2 mb-sm-0">
        <b-input
          v-if="editingItem.version"
          required
          id="item-value_installments"
          type="number"
          min="0"
          step="0.01"
          v-model="editingItem.version.value_installments"
        ></b-input>
        <b-input
          v-else
          required
          id="item-value_installments"
          type="number"
          min="0"
          step="0.01"
          v-model="editingItem.value_installments"
        ></b-input>
      </b-input-group>
    </b-form-group>
  </div>
  <!-- document -->
  <b-form-group label-for="item-document">
    <template #label>
      Contrato/Proposta (Documento)
    </template>
    <b-form-file
      v-if="editingItem.version"
      v-model="editingItem.version.file"
      class="mt-3"
      plain
    ></b-form-file>
    <b-form-file
      v-else
      v-model="editingItem.file"
      class="mt-3"
      plain
    ></b-form-file>
  </b-form-group>

  <!-- active -->
  <b-form-checkbox
    v-if="editingItem.pk"
    v-model="editingItem.version.active"
  >
    Ativo
  </b-form-checkbox>
  <b-form-checkbox
    v-else
    v-model="editingItem.active"
  >
    Ativo
  </b-form-checkbox>

</b-col>
</b-row>
<div v-if="message" class="notificacao error">{{ message }}</div>
</b-form>
</b-modal>
  </ValidationObserver>
</template>

<script>
import moment from 'moment';
import 'moment/locale/pt-br';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
    vSelect,
  },
  props: ['editingItem', 'namespace', 'isVisible'],
  data() {
    return {
      message: '',
      model: '',
      new_version: false,
      billing_recurrence: 0,
      billing_recurrence_start: null,
      has_hour_limit: null,
      has_timebank: null,
      time_bank_charge_date: null,
      hour_model: null,
      componentKey: 0,
      editingItem: {
        customer_pk: null,
        title: "",
        description: "",
        end_date: "",
        limit_months: null,
        currency_money: 'r',
        sinal: 0,
        success_fees_num: 0,
        active: false,
        index_of_readjustment: 1,
        start_date: '',
        date_of_readjustment: '',
        version: {
          contract_type: '',
          customer_pk: null,
          title: '',
          description: '',
          success_fees: 0,
          success_fees_num: 0,
          start_date: '',
          limit_months: 0,
          limit_hours: 0,
          contract_hours: 0,
          date_of_readjustment: '',
          index_of_readjustment: 1,
          index_type: 'IGPM',
          end_date: '',
          value: 0,
          currency_money: 'r',
          due_date: '',
          payment_type: 'v',
          document: null,
          active: true,
          sinal: 0,
          number_installments: 1,
          has_hour_limit: false,
          has_timebank: false,
          timebank_hour_value: 0,
          timebank_charge_frequency: 0,
          contract_model: 'hour_package',
          billing_recurrence: 0,
          file: null,
        }
      },
      state: {
        highlighted: {
          dates: [
            new Date()
          ],
          includeDisabled: true
        }
      },
      customers: [],
      contract_types: [
        { value: 'm', text: 'Mensal' },
        { value: 'h', text: 'Por hora' },
        { value: 'p', text: 'Projeto' },
      ],
      index_types: [
        { value: 'IGPM', text: 'IGPM' },
        { value: 'IPCA', text: 'IPCA' },
        { value: 'IPCAE', text: 'IPCA-E' },
        { value: 'IPC', text: 'IPC' },
      ],
      currency_moneys: [
        { value: 'r', text: 'Real', icon: 'R$' },
        { value: 'd', text: 'Dólar', icon: '$' },
        { value: 'e', text: 'Euro', icon: '€' },
      ],
      payment_types: [
        { value: 'v', text: 'A vista'},
        { value: 'p', text: 'Parcelado'},
        // { value: 'm', text: 'mensal'},
      ],
      billing_recurrences: [
        { value: 1, text: '1 mês' },
        { value: 2, text: '2 meses' },
        { value: 3, text: '3 meses' },
        { value: 4, text: '4 meses' },
        { value: 5, text: '5 meses' },
        { value: 6, text: '6 meses' },
      ],
      installmentsOptions: [
        { value: 1, text: '1x' },
        { value: 2, text: '2x' },
        { value: 3, text: '3x' },
        { value: 4, text: '4x' },
        { value: 5, text: '5x' },
        { value: 6, text: '6x' },
        { value: 7, text: '7x' },
        { value: 8, text: '8x' },
        { value: 9, text: '9x' },
        { value: 10, text: '10x' },
        { value: 11, text: '11x' },
        { value: 12, text: '12x' },
      ],
    }
  },
  mounted() {
    // Retorna somente clientes ativos.
    axios.get('/crm/customers/active/')
      .then(response => {
        this.customers = response.data.data
      })
  },
  computed: {
    hasTimeBank: {
      get() {
        return this.editingItem.timebank_charge_frequency ? true : this.editingItem.has_time_bank;
      },
      set(value) {
          if (this.editingItem.has_time_bank !== value) {
          this.editingItem.has_time_bank = value;
        }
      }
    },
    dueDateLabel() {
      const contractType = this.editingItem.pk ? this.editingItem.version.contract_type : this.editingItem.contract_type;
      const paymentType = this.editingItem.pk ? this.editingItem.version.payment_type : this.editingItem.payment_type;

      if (contractType === 'm') {
        return 'Data da primeira cobrança';
      } else if (contractType === 'p') {
        if (paymentType === 'v') {
          return 'Data da cobrança';
        } else if (paymentType === 'p') {
          return 'Data da primeira cobrança';
        }

        return 'Data da cobrança';
      }
    },
    // customers() {
    //   return this.$store.state.financial.cost_centers;
    // },
    icon() {
      const item = this.currency_moneys.find(currency => currency.value === this.editingItem.currency_money);
      return item ? item.icon : null;
    },
  },
  watch: {
    'editingItem.contract_type'() {
      // Quando muda o tipo de contrato, reseta os campos para o padrão.
      const propertiesToKeep = ['contract_type', 'currency_money', 'index_of_readjustment', 'index_type', 'value', 'payment_type', 'active'];

      // Mantém as propriedades que queremos e apaga as outras
      for (let key in this.editingItem) {
        if (!propertiesToKeep.includes(key)) {
          delete this.editingItem[key] // Ou você pode deletar com delete this.editingItem[key];
        }
      }
    },
    'editingItem.start_date'(contractStartDate) {
      // Adiciona 1 ano à data de início do contrato, definindo a data de reajuste automaticamente.
      const dateOfReadjustment = new Date(contractStartDate);
      dateOfReadjustment.setFullYear(dateOfReadjustment.getFullYear() + 1);
      this.editingItem.date_of_readjustment = dateOfReadjustment
    },
    'editingItem.number_installments'(numberInstallments) {
      const value = Number(this.editingItem.value);
      const sinal = this.editingItem.sinal ? Number(this.editingItem.sinal) : 0;
      this.editingItem.value_installments = Number((value - sinal) / numberInstallments).toFixed(2);
    },
  },
  methods: {
    handleCancel() {
      this.$emit('clear-modal')
      this.message = ''
    },
    async sendItem() {

      // Acessar o formulário por referência
      const form = this.$refs.modalForm;
  
      // Verifica se o formulário é válido (faz a validação personalizada)
      const formElements = form.elements;
      let isValid = true;

      // Itera sobre os campos do formulário e valida apenas os obrigatórios
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (element.required && !element.checkValidity()) {
          isValid = false;
          break;
        }
      }

      if (!isValid) {
        // Caso o formulário não seja válido, evita o envio e mostra uma mensagem
        this.isInvoiceSent = false;
        this.message = 'Por favor, preencha todos os campos obrigatórios. Marcados com (*)';
        return;
      }

      this.message = ''

      let contract = {}

      if (!this.editingItem.pk || this.editingItem.new_version) {

        if (!this.editingItem.pk) {
          // Se o modal não for a edição de um contrato
          // Define os campos que devem ser atribuídos ao contrato
          const keysToMove = ["customer_pk", "title", "description", "start_date", "end_date", "limit_months", "currency_money", "sinal", "success_fees_num", "active", "file"];

          // Move os campos para o contrato
          for (const key of keysToMove) {
            contract[key] = this.editingItem[key];
            delete this.editingItem[key];
          }

          // Pega o restante dos campos, e atribui à versão do contrato
          contract.version = { ...this.editingItem }
        }

        if (this.editingItem.new_version) {
          contract.version = { ...this.editingItem.version }
          contract.pk = this.editingItem.version.contract

          delete contract.version.pk
          delete contract.version.contract
        }
        // if (!this.validateRefund(this.editingItem, this.type)) {
        //   return
        // }
        this.$store.dispatch(this.namespace + '/addItem', contract)
          .then((response) => {
            if (response.status === 200) {
              this.$emit('success-response');
              this.$snotify.success(
                this.editingItem.new_version ? "Nova versão adicionada." : "Novo contrato adicionado.", "Sucesso", {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })
            } else {
              this.$snotify.error(
                this.editingItem.new_version ? "Erro ao adicionar nova versão." : "Erro ao adicionar novo contrato.", "Erro", {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })
            }
          });

        this.$emit('clear-modal')
      } else {
        contract = {...this.editingItem};
        // Aqui editando, logo um put
        this.$store.dispatch(this.namespace + '/editItem', contract)
          .then((response) => {
            if (response.status === 200) {
              this.$snotify.success(
                "Versão editada.", "Sucesso", {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })
            } else {
              this.$snotify.error(
                "Erro ao editar versão.", "Erro", {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })
            }
          });
        this.$emit('clear-modal');
      }
    },
  },
}
</script>

<style scoped>
.notificacao {
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px 0;
  margin-top: 2rem;
  border-radius: 4px;
}
</style>